import { render, staticRenderFns } from "./PackageFeatureManagement.vue?vue&type=template&id=add554c2&scoped=true&"
import script from "./PackageFeatureManagement.vue?vue&type=script&lang=js&"
export * from "./PackageFeatureManagement.vue?vue&type=script&lang=js&"
import style0 from "./PackageFeatureManagement.vue?vue&type=style&index=0&id=add554c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add554c2",
  null
  
)

export default component.exports